// Bootstrap 5 JS — only the components we actually use
import { Collapse, Dropdown, ScrollSpy } from 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {
  // ── Scroll-to-top button ──────────────────────────────────────────────────
  const scrollBtn = document.getElementById('scroll-top');
  if (scrollBtn) {
    const toggleVisible = () =>
      scrollBtn.classList.toggle('visible', window.scrollY > 400);
    window.addEventListener('scroll', toggleVisible, { passive: true });
    scrollBtn.addEventListener('click', () =>
      window.scrollTo({ top: 0, behavior: 'smooth' })
    );
  }

  // ── Active nav link (simple path-prefix match) ────────────────────────────
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
  document.querySelectorAll('.carc-navbar .nav-link').forEach((link) => {
    const href = (link.getAttribute('href') || '')
      .replace(/\/$/, '')
      .replace(/\/index\.html$/, '');
    if (!href || href === '#') return;
    const isHome = href === '' || href === '/index.html';
    if (isHome && (currentPath === '' || currentPath === '/')) {
      link.classList.add('active');
    } else if (!isHome && href !== '' && currentPath.startsWith(href)) {
      link.classList.add('active');
    }
  });

  // ── Sticky navbar shadow on scroll ───────────────────────────────────────
  const navbar = document.querySelector('.carc-navbar');
  if (navbar) {
    window.addEventListener(
      'scroll',
      () => navbar.classList.toggle('navbar-scrolled', window.scrollY > 10),
      { passive: true }
    );
  }
});
